import { Switch, Match } from "solid-js";
import type { MainProps } from "./_model";
import { global } from ":shared/app";

export default function AuthLayout(props: MainProps) {
  const $breakpoint = global.store.hooks.dom.useBreakpoints();
  return (
    // no need for fallback since we're using desktop as default!
    <Switch>
      {/* phones and tablets */}
      <Match when={$breakpoint()?.misc.lg.widthIsLess}>
        <main class="grid grid-rows-[100px_70%] w-full h-full content-center px-2 py-2 gap-2">
          <div class="flex w-full h-100px max-h-100px items-start overflow-hidden">
            <img class="w-fit h-full" src="/logo-auth.svg" alt="logo-auth" />
          </div>
          <section class="flex flex-col w-full h-full">{props.children}</section>
        </main>
      </Match>
      {/* desktop */}
      <Match when={true}>
        <main class="grid grid-cols-[40%_60%] w-full h-full">
          <div class="flex flex-col w-full h-full justify-center items-center pl-10 py-2 gap-3 overflow-y-auto overflow-x-hidden">
            <div class="flex w-full h-100px max-h-100px items-start overflow-hidden">
              <img class="w-fit h-full" src="/logo-auth.svg" alt="logo-auth" />
            </div>
            <section class="flex flex-col w-full h-fit overflow-hidden ">{props.children}</section>
          </div>
        </main>
      </Match>
    </Switch>
  );
}
